import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import ComplaintDetails from "./ComplaintDetails";
import ComplaintHeader from "./ComplaintHeader";
import { useParams } from "react-router-dom";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { ComplianceInvestigationBox } from "../../../leap-components/ComplianceInvestigations/ComplianceInvestigationBox";
import {
  loadComplaintAsync,
  selectComplaint,
} from "../../../redux/slices/complaint";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page500 from "../../../pages/auth/Page500";

const Complaint = () => {
  const [loading, setLoading] = useState(false);
  const [loadingComplaintId, setLoadingComplaintId] = useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const complaintSelector = useAppSelector(selectComplaint);

  const dispatch = useAppDispatch();

  let { profileNo, complaintId } = useParams();
  if (!profileNo || !complaintId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
    return <Loading />;
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingComplaintId !== complaintId) {
    setLoadingComplaintId(complaintId);
    dispatch(loadComplaintAsync(complaintId));
    return <Loading />;
  }

  const complaintDetails = complaintSelector.complaint;

  if (!complaintDetails) {
    return <Loading />;
  }

  if (!complaintDetails.response.ok) {
    if (complaintDetails.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ComplaintHeader
            licenceProfile={licenceProfile}
            complaintDetails={complaintDetails}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <ComplaintDetails complaintDetails={complaintDetails} />
        </Col>
      </Row>
      {complaintDetails.complianceInvestigationDetails && (
        <Row>
          <Col className="col-12 col-sm-12 col-md-12">
            <ComplianceInvestigationBox
              complianceInvestigationDetails={
                complaintDetails.complianceInvestigationDetails
              }
              licenceProfile={licenceProfile}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            complaintDetails={complaintDetails}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        complaintDetails={complaintDetails}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default Complaint;
